import type { ActionIdRegistry } from '@festina-life/core'
import { Alert } from '@festina-life/ui/feedback'
import { withErrorBoundary, withSuspense } from '@festina-life/ui/libs'
import { Stack } from '@festina-life/ui/structure'

import { getActionMetadata } from '../../hooks/navigation/categories/utils'
import { useFormatWarnings } from '../../hooks/useFormatWarnings'
import { useService } from '../../lenteHooks'
import { LifeErrorFallback } from '../errorFallback/LifeErrorFallback'

type Props = {
  actionId: keyof ActionIdRegistry
  entityId?: unknown
}

const CommandModalWarningsInternal = ({ actionId, entityId }: Props) => {
  const actionMetadata = useService('logic.actionMetadata')
  const metadata = getActionMetadata(actionMetadata, actionId)

  const warnings = metadata.useCreateWarnings?.(entityId)
  const formattedWarnings = useFormatWarnings(warnings ?? [])

  if (!formattedWarnings.length) {
    return null
  }

  return (
    <Alert severity="warning">
      <Stack as="ul" className="flex-col">
        {formattedWarnings.map((warning) => (
          <li key={warning}>{warning}</li>
        ))}
      </Stack>
    </Alert>
  )
}

export const CommandModalWarnings = withErrorBoundary(
  withSuspense(CommandModalWarningsInternal),
  {
    FallbackComponent: LifeErrorFallback,
  },
)
